<template>
  <div class="objects-views" v-loading="loader">
    <div class="list-objects tree">
      <div class="header-row">
        <div class="project-name">
          <span>{{ $store.state.project.name }}</span>

          <router-link :to="`/dashboard/jobs/all`">
            <img src="@/assets/settings.svg"/>
          </router-link>
        </div>
        <div>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <AddObject @update="newObject">
          <el-button class="add-new-object">+ Добавить объект</el-button>
        </AddObject>
        <div style="margin-left: 10px">
          <ImportFromEstimate  @update="fetchTree"/>
        </div>
      </div>
      <nested-draggable
        :isMain="true"
        @update="newObject"
        @input="updateTree"
        :value="list"
        v-if="list && list.length"
      />
      <div v-else class="warn">
        <el-alert
          title="У вас нет объектов"
          type="warning"
          description="Вы можете создать объект кликнув на кнопку в правом верхнем углу"
          show-icon
        >
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import nestedDraggable from '@/views/Dashboard/Objects/components/List';
import firebase from 'firebase';
import AddObject from '@/views/Dashboard/Objects/components/AddObject';
import {getChild} from '@/utils/getChild';
import {flatten} from '../../../utils/getChild';
import _ from 'lodash';
import ImportFromEstimate from "./components/ImportFromEstimate";

export default {
  name: 'ObjectsIndex',
  components: {
    ImportFromEstimate,
    AddObject,
    nestedDraggable,
  },

  methods: {
    async newObject() {
      await this.fetchTree();
      this.updateTree(this.list);
    },
    updateTree: _.debounce(function (tree) {
      this.list = [...tree];

      const jobs = flatten(this.list);

      jobs.forEach((job, i) => {
        this.update({...job, index: i});
      });
    }, 500),
    update(data) {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .doc(data.id)
        .update({
          index: data.index,
          name: data.name || null,
          parentId: data.parentId || null,
        });
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();

            result.push({
              id: subDoc.id,
              index: data.index,
              name: data.name,
              objects: data.objects || [],
              parentId: data.parentId || undefined,
            });
          });
        }).finally(() => {
          this.list = getChild(_.orderBy(result, 'index', ['asc']));

          this.loader = false;
        }).catch((e) => {
          this.loader = false;
        });
    },
  },

  mounted() {
    this.fetchTree();
  },


  data() {
    return {
      list: [],
      loader: false,
    };
  },
};
</script>

<style lang="scss">
.objects-views {
  display: flex;
  flex-direction: column;
  align-items: center;

  .list-objects {
    max-width: 600px;
    width: calc(100% - 20px);
  }

  .project-name {
    font-size: 16px;
    margin-top: 42px;
    display: flex;
    align-items: flex-end;
    background: #fff;
    justify-content: flex-start;
    padding: 0 10px;
    font-weight: bold;
  }
}

.tree, .tree ul {
  font: normal normal 14px/20px Helvetica, Arial, sans-serif;
  list-style-type: none;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.tree li {
  margin: 0;
  padding: 0 0 0 20px;
  position: relative;
}

.tree li::before, .tree li::after {
  content: '';
  position: absolute;
  left: 0;
}

/* horizontal line on inner list items */
.tree li::before {
  border-top: 1px solid #ccc;
  top: 24px;
  width: 20px;
  height: 0;
}

/* vertical line on list items */
.tree li:after {
  border-left: 1px solid #ccc;
  height: 100%;
  width: 0px;
  top: -55px;
}

.tree > li::after {
  top: -55px;
}

.tree > li:last-child::after {
  display: none !important;
}

.add-new-object {
  cursor: pointer;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.warn {
  margin-top: 20 pxs;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/Index.vue